import { render, staticRenderFns } from "./ClocksTable.vue?vue&type=template&id=313edad6&scoped=true&"
import script from "./ClocksTable.vue?vue&type=script&lang=js&"
export * from "./ClocksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313edad6",
  null
  
)

export default component.exports